import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { forgotPassword } from "../services";
import Logo from "../images/LogoLAENEW.png";
import ImagenLogin from "../images/legal_ia_login_bg_img.png";
import "./NewLogin.css";

const NewChangePassword = () => {
  const { t } = useTranslation("auth");
  const [email, setEmail] = useState("");

  const handleChange = (evt) => {
    setEmail(evt.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      toast.error(t("errors.emptyFields"));
      return;
    }
    let toastInfo = toast.info(t("password.sending"), { autoClose: false });
    const resp = await forgotPassword({ email });
    if (resp.status === 200) {
      toast.update(toastInfo, {
        render: t("password.emailSent"),
        type: toast.TYPE.SUCCESS,
        autoClose: true,
      });
    }
    if (resp?.status === 401 || resp?.status === 403) {
      toast.update(toastInfo, {
        render: t("errors.invalidCredentials"),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    }
    if (resp.status === 404) {
      toast.update(toastInfo, {
        render: t("password.userNotExist"),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-left__image" style={{ backgroundImage: `url(${ImagenLogin})` }}>
          <div className="login-left__overlay" />
          <p className="login-left__tagline">
            Analiza, conecta y<br />
            optimiza las<br />
            comunidades
          </p>
        </div>
      </div>

      <div className="login-right">
        <div className="login-logo">
          <img src={Logo} alt="GRUPOLAE FINCAS" />
        </div>

        <div className="login-right__content">
          <div className="login-form-card">
            <div className="login-header">
              <h1>{t("password.forgotTitle", "Recupera tu contraseña")}</h1>
              <p>{t("password.enterEmail", "Introduce tu email y te enviaremos un enlace para restablecer tu contraseña")}</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              <input
                id="email"
                name="email"
                type="email"
                placeholder="Email"
                value={email}
                onChange={handleChange}
                autoComplete="email"
                className="login-input"
              />

              <button type="submit" className="login-button">
                {t("password.send", "Enviar")}
              </button>
            </form>

            <div className="login-forgot">
              <Link to="/login">{t("password.backToLogin", "Volver al inicio de sesión")}</Link>
            </div>
          </div>
        </div>

        {/* <div className="login-footer">
          <Link to="#">Aviso legal</Link>
          <Link to="#">Política de Privacidad</Link>
          <Link to="#">Política de Cookies</Link>
        </div> */}
      </div>
    </div>
  );
};

export default NewChangePassword;
